import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import HostSettings from '../HostSettings';
import { appInsights } from '../Root';

const msalConfig = {
  auth: {
    clientId: HostSettings.applicationId,
    postLogoutRedirectUri: HostSettings.postLogoutRedirectUri,
    redirectUri: HostSettings.redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    iframeHashTimeout: 20000, // Applies just to silent calls - In milliseconds
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            appInsights.trackTrace({ message: message, severityLevel: 3 });
            console.error(message);
            return;
          case LogLevel.Warning:
            appInsights.trackTrace({ message: message, severityLevel: 2 });
            console.warn(message);
            return;
          default:
            return;
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

const msal = new PublicClientApplication(msalConfig);

export default msal;
